import React from "react";

const Datenschutzerklaerung = () => (
  <div>
    Nach §§ 14 bis 16 KDG (Kirchliches Datenschutzgesetz) informiert Sie das
    Dekanat Wetterau-West über die Verarbeitung Ihrer personenbezogenen Daten
    durch die Teilnahme am Kreativspiel „Ideen säen“.
    <h3>1. Verantwortlich im Sinne von § 4, Abs. 9 KDG</h3>
    Dekanat Wetterau-West
    <br />
    Karlstraße 35
    <br />
    61231 Bad Nauheim
    <br />
    <br />
    Tel: 06032-931313
    <br />
    Fax: 06032-931312
    <br />
    <br />
    E-Mail:{" "}
    <a href="mailto:dekanat.wetterau-west@kirche-wetterau.de">
      dekanat.wetterau-west@kirche-wetterau.de
    </a>
    <h3>2. Betrieblicher Datenschutzbeauftragter</h3>Ein gemeinsamer
    betrieblicher Datenschutzbeauftragter ist bestellt und wie folgt zu
    erreichen:
    <br />
    <br />
    Gemeinsamer betrieblicher Datenschutzbeauftragter für die Kirchengemeinden
    im Bistum Mainz
    <br />
    Postfach 1560
    <br />
    <br />
    55005 Mainz
    <br />
    Tel: 06131 253889
    <br />
    <br />
    E-Mail:{" "}
    <a href="mailto:datenschutz.kirchengemeinden@bistum-mainz.de">
      datenschutz.kirchengemeinden@bistum-mainz.de
    </a>
    <h3>3. Datenverarbeitung durch die Anmeldung zum Spiel</h3>Zum Kreativspiel
    „Ideen Säen“ haben sogenannte „Sämänner“ und „Erntehelfer“ Zugriff (s.{" "}
    <a href="/regeln">Spielregeln</a>). Für diese Rollen werden die folgenden
    Daten erhoben:
    <br />
    <br />
    Vor- und Zuname
    <br />
    Gemeinde, die die Person vertritt
    <br />
    E-Mail
    <br />
    Alle eingereichten Berichte
    <br />
    <br />
    Bei der Anmeldung zum Spiel bestätigen die Sämänner schriftlich und die
    Erntehelfer elektronisch die Zustimmung zu dieser Datenverarbeitung.
    <br />
    Falls keine andere Vereinbarung getroffen wird, werden alle angegebenen
    Daten spätestens einen Monat nach Ende des Kreativspiels „Ideen säen“
    gelöscht.
    <br />
    Das Dekanat Wetterau-West gehört zum Bistum Mainz. Daher gilt die{" "}
    <a href="https://bistummainz.de/portal/datenschutzerklaerung/">
      Datenschutzerklärung des Bistums Mainz
    </a>{" "}
    analog.
  </div>
);

export default Datenschutzerklaerung;
